import { getLogger } from '@packages/core/logging';

import type { WorksheetFormEntity } from '../entities';

import { StsBackendOperation } from '../../../sts-backend-operation';
import { toWorksheetFormEntity } from '../helpers';

const logger = getLogger('worksheets.forms');

/** Parameters for fetching a worksheet form definition. */
export type FetchFormParams = {
    /** The ID of the worksheet form to fetch. */
    worksheetFormId: string;
};

/**
 * Fetches a worksheet form definition by its ID.
 * Used when opening a worksheet for editing.
 */
export class FetchForm extends StsBackendOperation {
    /**
     * Fetch a worksheet form definition by ID and map it to a domain entity.
     *
     * @param params - the worksheet form to fetch
     * @returns the worksheet form entity, or undefined if the fetch fails or is aborted
     */
    async exec(params: FetchFormParams): Promise<WorksheetFormEntity | undefined> {
        try {
            const { worksheetFormId } = params;
            const response = await this.client.fetchWorksheetFormById({ worksheetFormId });

            if (!response.success) {
                return undefined;
            }

            return toWorksheetFormEntity(response.data);
        } catch (e) {
            logger.error('Failed to fetch the worksheet form', { error: e });
        }
    }
}
